import React, { useState, useEffect } from 'react';
import { useFetchAuthedData } from "helpers/utils";
import { follow, unfollow } from "store/authSlice";
import { useDispatch } from 'react-redux';
import { FaUserPlus, FaCheck } from "react-icons/fa6";
import { useAuth } from "providers/AuthContext";

export default function FollowBtn({ username }) {
  const { userInfo, isFetching } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const dispatch = useDispatch();

  // Fetch current follow status
  const { data: followStatus } = useFetchAuthedData(
    `followstatus/${username}`,
    [username],
  );

  const followUser = async () => {
    try {
      await dispatch(follow({ username: username })).unwrap();
    } catch (err) {
      alert('There was an issue following this person. Please try again or contact support.')
    }
  };
  
  const unfollowUser = async () => {
    try {
      await dispatch(unfollow({ username: username })).unwrap();
    } catch (err) {
      alert('There was an issue un-following this person. Please try again or contact support.');
    } 
  };


  // Set initial follow state from API response
  useEffect(() => {
    if (followStatus?.isFollowing !== undefined) {
      setIsFollowing(followStatus.isFollowing);
    }
  }, [followStatus]);

  const toggleFollow = async () => {
    try {
      if (isFollowing) {
        await unfollowUser();
      } else {
        await followUser();
      }
      setIsFollowing(!isFollowing);
    } catch (err) {
      console.error(`Error toggling follow for ${username}:`, err);
      // Optionally show error to user
    }
  };


  return (
    <>
      {!isFetching && username !== userInfo.username && (
        <button
          onClick={toggleFollow}
          className={`
            px-2 py-1  text-[11px] md:text-[13px] flex items-center border-[1px] border-black rounded-full
            ${isFollowing 
              ? 'text-white bg-brg' 
              : 'text-black'
            }
          `}
        >
          {isFollowing ? (
            <FaCheck className="mr-1 text-white" />
          ) : (
            <FaUserPlus className="mr-1" />
          )}
          {(isFollowing ? 'Following' : 'Follow')}
        </button>
      )}
    </>
  );
}